import React from 'react';
import DocumentIcon from '@stack/assets/images/document-icon.svg';
import ImageIcon from '@stack/assets/images/image-icon.svg';
import PDFIcon from '@stack/assets/images/pdf-icon.svg';
import Image from 'next/image';

import { FileTypeIconProps } from './props';

export const FileTypeIcon: React.FC<FileTypeIconProps> = (props) => {
  const { fileType, color = '#EC6C0C', ...rest } = props;

  let icon = DocumentIcon;
  if (fileType === 'application/pdf') {
    icon = PDFIcon;
  }
  if (
    fileType === 'image/png' ||
    fileType === 'image/jpg' ||
    fileType === 'image/jpeg'
  ) {
    icon = ImageIcon;
  }
  return <Image height={20} width={20} alt="logo" src={icon} color={color} />;
};

export default FileTypeIcon;
